import PropTypes from "prop-types";
import React from "react";
import "./OrganisationNode.css";

const propTypes = {
	nodeData: PropTypes.object.isRequired,
};

const OrganisationNode = (props) => {
	//console.log("OrganisationNode props =", props);
	const handleClick = () => {
		//props.selectNode(props.nodeData);
	};
	return (
		<div onClick={handleClick(props.nodeData)}>
			<div className="position">{props.nodeData.title}</div>
			<div className="fullname">{props.nodeData.name}</div>
		</div>
	);
};

OrganisationNode.propTypes = propTypes;

export default OrganisationNode;
